var { FADE_OUT_DURATION } = require('./UnicornCelebration.types');

/**
 * Overlay styles for the UnicornCelebration component
 */
var overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  pointerEvents: 'none',
  overflow: 'hidden',
};

/**
 * Click target overlay (invisible but catches clicks)
 */
var clickTargetStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9998,
  pointerEvents: 'auto',
  cursor: 'pointer',
  background: 'transparent',
};

/**
 * Get overlay style with fade state
 * @param {boolean} isFadingOut - Whether fading out
 * @returns {Object} - Style object
 */
function getOverlayStyle(isFadingOut) {
  return Object.assign({}, overlayStyle, {
    opacity: isFadingOut ? 0 : 1,
    transition: 'opacity ' + FADE_OUT_DURATION + 'ms ease-out',
  });
}

/**
 * Get click target style with fade state
 * @param {boolean} isFadingOut - Whether fading out
 * @returns {Object} - Style object
 */
function getClickTargetStyle(isFadingOut) {
  return Object.assign({}, clickTargetStyle, {
    opacity: isFadingOut ? 0 : 1,
    transition: 'opacity ' + FADE_OUT_DURATION + 'ms ease-out',
  });
}

module.exports = {
  overlayStyle: overlayStyle,
  clickTargetStyle: clickTargetStyle,
  getOverlayStyle: getOverlayStyle,
  getClickTargetStyle: getClickTargetStyle,
};
